'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import * as SubframeUtils from '../utils';
import { Dialog } from './Dialog';
import { Button } from './Button';
import { AlertTriangle, Trash2, LogOut } from 'lucide-react';
interface ConfirmationModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  variant?: 'destructive' | 'neutral';
  loading?: boolean;
}
export function ConfirmationModal(t0) {
  const $ = _c(37);
  const {
    isOpen,
    onOpenChange,
    title,
    description,
    confirmText: t1,
    cancelText: t2,
    onConfirm,
    variant: t3,
    loading: t4
  } = t0;
  const confirmText = t1 === undefined ? "Confirmar" : t1;
  const cancelText = t2 === undefined ? "Cancelar" : t2;
  const variant = t3 === undefined ? "neutral" : t3;
  const loading = t4 === undefined ? false : t4;
  const Icon = variant === "destructive" ? Trash2 : LogOut;
  const iconColor = variant === "destructive" ? "text-error-600" : "text-neutral-600";
  const iconBg = variant === "destructive" ? "bg-error-50" : "bg-neutral-50";
  const confirmButtonVariant = variant === "destructive" ? "destructive-primary" : "brand-primary";
  const t5 = `mx-auto flex h-12 w-12 items-center justify-center rounded-full ${iconBg}`;
  const t6 = `h-6 w-6 ${iconColor}`;
  let t7;
  if ($[0] !== Icon || $[1] !== t6) {
    t7 = <Icon className={t6} />;
    $[0] = Icon;
    $[1] = t6;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== t5 || $[4] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[3] = t5;
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== title) {
    t9 = <span className="text-lg font-bold text-neutral-900">{title}</span>;
    $[6] = title;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== description) {
    t10 = <span className="text-sm text-neutral-500">{description}</span>;
    $[8] = description;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = <div className="flex flex-col gap-2">{t9}{t10}</div>;
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11 || $[14] !== t8) {
    t12 = <div className="flex flex-col gap-4">{t8}{t11}</div>;
    $[13] = t11;
    $[14] = t8;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== onOpenChange) {
    t13 = () => onOpenChange(false);
    $[16] = onOpenChange;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== cancelText || $[19] !== loading || $[20] !== t13) {
    t14 = <Button variant="neutral-secondary" onClick={t13} disabled={loading} className="flex-1 justify-center">{cancelText}</Button>;
    $[18] = cancelText;
    $[19] = loading;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== confirmButtonVariant || $[23] !== confirmText || $[24] !== loading || $[25] !== onConfirm) {
    t15 = <Button variant={confirmButtonVariant} onClick={onConfirm} loading={loading} className="flex-1 justify-center">{confirmText}</Button>;
    $[22] = confirmButtonVariant;
    $[23] = confirmText;
    $[24] = loading;
    $[25] = onConfirm;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = <div className="flex w-full items-center justify-end gap-3">{t14}{t15}</div>;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t12 || $[31] !== t16) {
    t17 = <Dialog.Content className="w-full max-w-[400px] gap-6 overflow-hidden rounded-xl p-6">{t12}{t16}</Dialog.Content>;
    $[30] = t12;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== isOpen || $[34] !== onOpenChange || $[35] !== t17) {
    t18 = <Dialog open={isOpen} onOpenChange={onOpenChange}>{t17}</Dialog>;
    $[33] = isOpen;
    $[34] = onOpenChange;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
}